import React, { Component } from 'react'
import { Button } from 'hhsoig-design-system-core'
import { joinClassNames } from '../../utilities'
import css from './PrintReview.module.css'

export class PrintReview extends Component {
  state = {
    shouldHide: true
  }

  render() {
    let helpTextClass = joinClassNames(
      'ds-u-font-size--h2',
      'ds-u-fill--gray-lightest',
      'ds-u-margin-top--3',
      css.header
    )
    return (
      <div className={this.props.className}>
        <h2>Print or save a copy for your records</h2>
        <p className="ds-text--lead">
          Before you submit, make sure you save a copy for your records. You
          won't be able to print or save your responses after you submit.
        </p>
        <Button onClick={() => window.print()}>Print</Button>
        <div
          className={helpTextClass}
          onClick={() => this.setState({ shouldHide: !this.state.shouldHide })}
        >
          Need help saving your summary as PDF?
        </div>
        <div
          className={
            this.state.shouldHide
              ? css.hidden
              : 'ds-text--lead ds-u-margin-top--0'
          }
        >
          To save your complaint, click the Print button. For Windows, under
          "Select Printer" click "Adobe PDF". For Mac, under the "Destination"
          dropdown, click "Save as PDF". The exact wording and location may
          vary. Name the file, select a desitnation to save the file, and click
          "Save".
        </div>
      </div>
    )
  }
}
